
export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname

/**
 * Converts a storage path to a full URL.
 *
 * - If the path is empty, returns an empty string.
 * - If the path starts with "/storage" or "storage":
 *    - Prepends the API base URL (`REACT_APP_API_URL`) to create a full URL.
 *    - Removes "/api" from the URL if it exists immediately after the domain.
 * - Otherwise, returns the path as-is (assumes it's already a full URL or another relative path).
 *
 * @param {string} path - The relative storage path or URL.
 * @returns {string} - Full URL to access the storage resource.
 *
 * @example
 * getFullUrl("/storage/company/31/file.png")
 * // "http://localhost:8000/storage/company/31/file.png"
 *
 * getFullUrl("http://example.com/image.jpg")
 * // "http://example.com/image.jpg"
 */
export const getFullUrl = (path: string) => {
    if (!path || typeof path !== 'string') return "";
    // If path already starts with storage
    if (path?.startsWith("/storage") || path?.startsWith("storage")) {
        let baseUrl = `${process.env.REACT_APP_API_URL}${path?.startsWith("/") ? "" : "/"}${path}`;
        return baseUrl.replace(/\/api(?=\/)/, "");
    }
    // Otherwise return as usual
    return path
}

export const changeBranding = (title: string, url: string) => {
    document.title = title;
    let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
    if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
    }
    link.href = url;
};
export const toCompanyLogo = (key: string) => {
    const logos = {
        '24': toAbsoluteUrl('/media/logos/indo-saving-connection.png'),
        "25": toAbsoluteUrl('/media/images/mitr_logo.png'),
    }
    return logos[key as keyof typeof logos] || toAbsoluteUrl('/media/logos/log_2.png');
};
